import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryStringCaseInsensitive from "@insite/client-framework/Common/Utilities/parseQueryStringCaseInsensitive";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EditTermsForm from "@tKgpco/Components/Terms/EditTermsForm";
import loadTerm from "@tKgpco/Handlers/Terms/LoadTerm";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    loadTerm,
};

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    let termId;
    if (location && location.search) {
        const parsedQuery = parseQueryStringCaseInsensitive(location.search, {
            termId: "",
        });
        termId = parsedQuery.termId;
    }
    return {
        isLoading: state.KGPState.customEditTerm.isLoading,
        termId,
        quoteTerm: state.KGPState.customEditTerm.quoteTerm,
    };
};

interface CustomWidgetStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

const styles: CustomWidgetStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const EditTermsPage: React.FC<Props> = ({ id, loadTerm, quoteTerm, termId, isLoading }) => {
    useEffect(() => {
        if (!isLoading && termId) {
            loadTerm({ id: termId });
        }
    }, [termId]);
    if (isLoading) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }

    if (!quoteTerm) {
        return null;
    }

    return <EditTermsForm quoteTerm={quoteTerm} />;
};

const editTermsPage: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(EditTermsPage),
    definition: {
        group: "Basic",
    },
};

export default editTermsPage;
